import { Extension } from "@tiptap/core"
import { Suggestion } from "@tiptap/suggestion"
import { createSuggestionPopup } from "./suggestion_popup"

const COMMANDS = [
  {
    title: "Heading 1",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setHeading({ level: 1 }).run()
    },
  },
  {
    title: "Heading 2",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setHeading({ level: 2 }).run()
    },
  },
  {
    title: "Heading 3",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setHeading({ level: 3 }).run()
    },
  },
  {
    title: "Bullet List",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleBulletList().run()
    },
  },
  {
    title: "Ordered List",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleOrderedList().run()
    },
  },
  {
    title: "Blockquote",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleBlockquote().run()
    },
  },
  {
    title: "Code Block",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).toggleCodeBlock().run()
    },
  },
  {
    title: "Divider",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).setHorizontalRule().run()
    },
  },
  {
    title: "Image",
    command: ({ editor, range }) => {
      editor.chain().focus().deleteRange(range).run()
      const input = document.createElement("input")
      input.type = "file"
      input.accept = "image/*"
      input.onchange = () => {
        const file = input.files?.[0]
        if (file) {
          const event = new CustomEvent("tiptap:upload-image", {
            detail: { file },
            bubbles: true,
          })
          editor.view.dom.dispatchEvent(event)
        }
      }
      input.click()
    },
  },
]

export function createSlashCommandsExtension() {
  const popup = createSuggestionPopup()

  return Extension.create({
    name: "slashCommands",

    addProseMirrorPlugins() {
      return [
        Suggestion({
          editor: this.editor,
          char: "/",
          startOfLine: true,

          items({ query }) {
            return COMMANDS.filter((cmd) =>
              cmd.title.toLowerCase().includes(query.toLowerCase())
            )
          },

          command({ editor, range, props }) {
            props.command({ editor, range })
          },

          render() {
            return popup
          },
        }),
      ]
    },
  })
}
